import React from "react";

export const GovBackedBanner = () => (
  <div
    className="bg-white rounded-2xl p-5 sm:p-6 border border-[#E5E5E0] shadow-[0_20px_60px_-30px_rgba(5,47,36,0.4)]"
    data-testid="gov-backed-banner"
  >
    <h2
      className="font-display font-extrabold tracking-tight leading-[1.05] text-xl sm:text-2xl"
      data-testid="gov-backed-heading"
    >
      Government-backed{" "}
      <span className="inline-block bg-[#052F24] text-[#DFFF00] px-2 -rotate-1">business loans</span>
    </h2>
    <p className="mt-2.5 text-sm font-light text-[#052F24]/55 leading-relaxed" data-testid="gov-backed-copy">
      We're supporting more businesses than ever by offering Government-backed loans under the Growth Guarantee Scheme - subject to eligibility.
    </p>
  </div>
);
